export default {
  path: '/sign-name',
  meta: {
    title: '签名',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/sign-name`),
}



// WEBPACK FOOTER //
// ./src/views/signName/router.js